module.exports = __webpack_public_path__ + "img/W7042-mod.331cfdbf.jpg";